import { ValidatorFn } from '@angular/forms';

export function matchesOtherValidator(key1, key2): ValidatorFn {
  return (control: any): { [key: string]: any } => {
    if (!control.controls[key1]) {
      return { fail: key1 + ' does not exist' };
    }
    if (!control.controls[key2]) {
      return { fail: key2 + ' does not exist' };
    }

    if (control.controls[key1].value !== control.controls[key2].value) {
      return { matchesOtherValidator: { field: key1, remoteField: key2 } };
    }
  };
}
